import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class VehicleRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }
  async getVehicles() {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/api/vehicle?provider=true`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }
}

Container.set({ id: VehicleRepository, type: VehicleRepository });

export default VehicleRepository;
